import { apiFetch } from './client';
import type { CurrentUser } from './types';

export function getCurrentUser(): Promise<CurrentUser> {
  return apiFetch<CurrentUser>('/api/me');
}
